<script>
    import HomeAboutMedia from "@finamill/components/HomeAboutMedia.vue";
    import HomeAboutText from "@finamill/components/HomeAboutText.vue";

    export default {
        name: "HomeAbout",
        components: {
            HomeAboutMedia,
            HomeAboutText,
        },
    };
</script>

<template>
    <section class="home-about">
        <div class="home-about__inner">
            <home-about-media />
            <home-about-text />
        </div>
    </section>
</template>

<style lang="scss">
    .home-about {
        @include bp($bp-desktop-sm) {
            background-color: #9bb49c;
        }
    }

    .home-about__inner {
        @include bp($bp-desktop-sm) {
            display: flex;
            flex-direction: row-reverse;
            max-width: 1440px;
            margin: 0 auto;
        }
    }
</style>
